module.exports = __webpack_public_path__ + "static/logo-7283f1c5d1d7360596595575253b0f9b.png";